<template>
    <div class="body-info body-content-description has-footer-absolute" :class="{ 'themed-scrollbar' : isDesktop }">
        <form class="description-form" :novalidate="true">
            <p class="content-description" v-html="modalData.content.inputs.title.label"/>
            <div class="input-wrapper over-sized">
                <input v-model="descriptionTitle" id="descriptionTitle" :type="modalData.content.inputs.title.type" min="3" maxlength="50" class="normal-input free-label" required/>
                <label for="descriptionTitle" v-html=""/>
            </div>
            <p class="content-description" v-html="modalData.content.inputs.body.label"/>
            <div class="input-wrapper textarea-wrapper">
                <textarea v-model="descriptionBody" id="descriptionText" maxlength="1000" class="normal-input free-label themed-scrollbar" required/>
            </div>
            <div class="saved-list-container" :class="{ 'has-items' : selectedProductsList.length }">
                <div v-if="selectedProductsList" class="product-shop-list themed-scrollbar">
                    <div v-for="item in selectedProductsList" class="shop-item" :id="'shop-item-' + item.groupId">
                        <img :src="item.img" class="item-img" :alt="item.name"/>
                        <div class="mx-0 item-info-container">
                            <div class="col pl-0 prod-labels">
                                <p class="item-label name-label"> {{ item.name }} </p>
                                <p class="item-label light variant-label"> {{ item.label }} </p>
                            </div>
                            <div class="col-12 px-0 mt-auto action-labels">
                                <p class="item-label light qty-label"> {{ kStrings.kQUANTITY + ': ' }} <span> {{ item.quantity ? item.quantity : 1 }} </span> </p>
                            </div>
                        </div>
                        <i class="ecom-close remove-selected" @click="removeProdListItem(item)"/>
                    </div>
                </div>
            </div>
            <div class="button-wrapper mt-3">
                <button class="pastime-button light" @click.prevent="toggleCatalogCart">
                    {{ kStrings.kADD_PRODUCT_RECIPES }}
                </button>
            </div>
        </form>
        <div class="button-wrapper modal-absolute" :class="{ 'fit-content' : isDesktop }">
            <button class="pastime-button dark-mode" type="submit" @click.prevent="descriptionFormSubmit" :disabled="!enableDescriptionFormSubmit">
                {{ kStrings.kSAVE_CHANGES }}
            </button>
        </div>
    </div>
</template>

<script>

import {store} from '@/store/pastimes';
import {isEmpty} from 'lodash-es';

export default {
    store,
    name: 'DescriptionForm',
    components: {},
    props: {
        //prop1: {type: Object, default: null, required: false}
    },
    data() {
        return {
            // description form 
            descriptionTitle: null,
            descriptionBody: null,
        }
    },
    computed: {
        isDesktop() {
            return this.$store.getters.isDesktop;
        },
        kStrings() {
            return this.$store.getters.kStrings;
        },
        modalData() {
            return this.$store.getters.modalData;
        },
        // form variables
        descriptionForm() {
            return !isEmpty(this.$store.getters['registrationPage/descriptionForm']) ? this.$store.getters['registrationPage/descriptionForm'] : null;
        },
        pastimeInfo() {
            return this.$store.getters.pastimeInfo;
        },
        requireUsedProducts() {
            return this.pastimeInfo.baseInfo.requireUsedProducts;
        },
        enableDescriptionFormSubmit() {
            let descriptionTitleOk = !isEmpty(this.descriptionTitle); 
            let descriptionBodyOk = !isEmpty(this.descriptionBody); 
            let selectedProductsListOk = !this.requireUsedProducts || !isEmpty(this.selectedProductsList); 
            
            return descriptionTitleOk && descriptionBodyOk && selectedProductsListOk;
        },
        selectedProductsList() { // store list to submit
            const list = this.$store.getters['registrationPage/selectedProductsList'];
            return !isEmpty(list) ? list : []
        },
    },
    watch: {
        selectedProductsList(value){
            this.$emit('set-sub-header', value.length + ' ' + this.kStrings.kPRODUCTS_SELECTED);
        }
    },
    created() {
    },
    mounted() {
        this.$nextTick(() => {
            // set default v-models if available
            this.setDefaultDescriptionForm();
        });
    },
    methods: {
        setDefaultDescriptionForm() {
            this.descriptionTitle = !isEmpty(this.modalData.content.inputs.title.defaultValue) ? this.modalData.content.inputs.title.defaultValue : '';
            this.descriptionBody = !isEmpty(this.modalData.content.inputs.body.defaultValue) ? this.modalData.content.inputs.body.defaultValue : '';
            this.productsList = !isEmpty(this.selectedProductsList) ? this.selectedProductsList : [];
        },
        descriptionFormSubmit(close = true) {
            let data = {
                title: this.descriptionTitle,
                description: this.descriptionBody,
                selectedProductsList: this.selectedProductsList,
            };
            this.$store.dispatch('registrationPage/setDescriptionForm', data);
            if(close) {
                this.$store.dispatch('setModalStatus', {status: false, context: null});
            }
        },
        toggleCatalogCart() {
            this.descriptionFormSubmit(false);
            this.$store.dispatch('setModalStatus', {status: true, context: 'catalogCart', isMixType: true});
        },
        async removeProdListItem(prod = null) { // adds / remove items from selection
            if(prod) {
                await this.$store.dispatch('registrationPage/removeSelectedProducts', prod);
            }
        },
    }
};
</script>

<style scoped>

</style>